<template>
<div>
  <h2>
    <a-icon type="team" /> Пользователи {{allMembersList.length && `(${allMembersList.length})` }}
    <AddUserButton
      v-for="o in addButtonsData" :key="o.name"
      :text='o.name'
      :icon="o.icon"
      :amount="o.amount"
    />
  </h2>

  <Nodata v-if="!allMembersList.length" />
  <WithData v-else />

</div>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import ResultsContainer from '../ResultsContainer';
import AddUserButton from './AddUserButton';
import Nodata from './Nodata';
import WithData from './WithData';

export default {
  name: 'UsersList',
  components: {
    ResultsContainer,
    AddUserButton,
    WithData,
    Nodata,
    mapState
  },
  data () {
    return {
      activeKey:  '',
      addButtonsData: [
      {
        name: '+Добавить',
        amount: 1,
        icon: 'user-add'
      },
      {
        name: '+5',
        amount: 5
      }]
    }
  },
  computed: {
    allMembersListReversed () {
      return this.allMembersList.reverse()
    },
    ...mapState([
      'currentGroup',
      'allMembersList',
      'setCurrentMember'
    ]),
    ...mapGetters([
      'getGroup',
      'getInArray'
    ])
  },
}
</script>
<style scoped lang="scss">

.create-link-btn {
  display: inline-block;
  margin-bottom: 20px;
}
</style>